// delay.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DelayGuard implements CanActivate {
  canActivate(): Observable<boolean> {
    return of(true).pipe(
      delay(4000), // wait 4 seconds
      map(() => true)
    );
  }
}
